import React from 'react';
import { Link } from 'gatsby';
import classNames from 'classnames';

import HeroIcons from './HeroIcons/HeroIcons';
import CtaForm from 'Component/CtaForm/CtaForm';

import css from './Hero.module.scss';

const Hero = ({
	breadcrumbs,
	heading,
	description,
	iconsData,
	ctaFormText,
	customClass,
	directMF,
}) => {
	return (
		<section className={classNames(css.hero, css[customClass], 'fontWhite')}>
			{breadcrumbs && (
				<ol className={css.breadcrumbs}>
					{breadcrumbs.map((item, index) => (
						<li key={index}>
							<Link to={`/${item.link}`}>{item.text}</Link>
						</li>
					))}
				</ol>
			)}
			<h1>{heading}</h1>
			{description && <h3>{description}</h3>}
			{iconsData && (
				<div className={css.heroIcons}>
					{iconsData.map(props => (
						<HeroIcons key={props.id} customClass={customClass} {...props} />
					))}
				</div>
			)}
			<div className={css.cta}>
				{ctaFormText && <span className={css.heading}>{ctaFormText}</span>}
				<CtaForm customClass="inHero" />
			</div>
			{directMF && (
				<Link to="#" className={css.directMFBtn}>
					<button>Switch to Direct</button>
				</Link>
			)}
		</section>
	);
};
export default Hero;
